export default __webpack_public_path__ + "static/media/Indian_Bank_Logo.73566b51.png";